//@ts-nocheck
/* 
 *  This file super-user-server-error-handler.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { throwError, forkJoin } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { LogErrorsService } from './log-errors';
import { SnackbarAlertService } from '../snackbar-alert.service';
import { ConfigurationService } from '../configuration.service';
import { superUserMenuNavigationModel } from '../../constants/routing-constant';

@Injectable()
export class SuperUserServerErrorHandlerService {

    constructor(
        private router: Router,
        private logErrorService: LogErrorsService,
        private snackbarAlertService: SnackbarAlertService,
        public configurationService: ConfigurationService,
        private httpClient: HttpClient
    ) {
    }

    handleServerError(err: HttpErrorResponse, isUnauthorize?): any {
        const isLogin = localStorage.getItem('authlogin');
        if (navigator.onLine) {
            this.logErrorService.logError(err);
            if (isLogin || isUnauthorize) {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 403) {
                        this.snackbarAlertService.Alert(`Session has expired, please login again`, '2');
                        localStorage.removeItem('authlogin');
                        localStorage.removeItem('superUserAccessRights');
                        localStorage.removeItem('start_token_time');
                        localStorage.removeItem('superUserLogOnDetails');
                        this.router.navigate(['/product-management/login']);
                    } else if (err.status === 0) {
                        this.snackbarAlertService.Alert('You are in low internet bandwidth. Please check and try again', '2');
                    } else if (err.status === 426) {
                        if (typeof err.error === 'string') {
                            this.snackbarAlertService.Alert(err.error, '2');
                        }
                        this.onRefreshLogon();
                    } else if (err.status !== 306) {
                        if (err.error && err.error.message && err.error.validationType && err.error.validationType == '3') {
                            this.snackbarAlertService.Alert(err.error.message, '3');
                        } else if (err.error && err.error.message) {
                            this.snackbarAlertService.Alert(err.error.message, '2');
                        } else if (err.error && err.error.error_description) {
                            this.snackbarAlertService.Alert(err.error.error_description, '2');
                        } else if (err.error && err.error.error) {
                            if (err.error.error != 'invalid_grant') {
                                this.snackbarAlertService.Alert(err.error.error, '2');
                            }
                        } else if (typeof err.error === 'string') {
                            this.snackbarAlertService.Alert(err.error, '2');
                        } else {
                            this.snackbarAlertService.Alert('An error occurred: ' + err.name, '2');
                        }
                    }
                } else {
                    this.snackbarAlertService.Alert(`Unknown error`, '2');
                }
            }
        } else {
            this.snackbarAlertService.Alert(`Please check your internet connection`, '2');
        }
        return throwError(err);
    }

    onRefreshLogon(): void {
        if (localStorage.getItem('authlogin')) {
            const url = this.configurationService.base_url + '/api/superuser/logOn/UserDetail';
            const headers = { headers: this.getHeaders() };
            this.httpClient.get(url, headers)
                .subscribe(() => {
                    this.getMenusAndRights().then();
                });
        }
    }

    getMenusAndRights(): Promise<boolean> {
        const userName = JSON.parse(localStorage.getItem('authlogin')).userName;
        const headers = { headers: this.getHeaders() };
        return new Promise((resolve, reject) => {
            const MenuModelObject = {
                menuType: '',
                parentKey: 9999,
                menuId: 0
            };
            const menuList = this.httpClient.post(this.configurationService.base_url + '/api/superuser/logOn', MenuModelObject, headers);
            const superUserDetails = this.httpClient.get(this.configurationService.base_url + '/api/superuser/Details?superUserId=' + userName, headers);
            forkJoin([menuList, superUserDetails])
                .pipe(
                    first(),
                    tap((data: any) => {
                        superUserMenuNavigationModel.forEach(item => {
                            try {
                                data[0].find(e => e.navigationCode === item.code).navigationPath = item.path;
                            } catch (e) { }
                        });
                        localStorage.setItem('superUserAccessRights', JSON.stringify(data[0]));
                        localStorage.setItem('superUserLogOnDetails', JSON.stringify(data[1]));
                        resolve(true);
                    })
                ).toPromise().then(() => { }).catch(() => {
                    reject(false);
                });
        });
    }

    getHeaders(): HttpHeaders {
        const authlogin = JSON.parse(localStorage.getItem('authlogin'));
        const accessToken = authlogin ? authlogin.access_token : '';
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'domainCode': this.configurationService.domainCode,
            'Authorization': 'Bearer ' + accessToken,
            'AccessMode': 'W'
        });
    }
}